import React, { useState } from "react";
import "./IdeaCard.css";

const IdeaCard = () => {
  const [note, setNote] = useState("");

  return (
    <div className="idea-card">
      <div className="idea-header">
        <input
          type="text"
          className="idea-title"
          placeholder="Headline"
        />
        <div className="idea-menu">⋮</div>
      </div>

      <textarea
        className="idea-body"
        placeholder="type your note..."
        maxLength={500}
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />

      <div className="idea-footer">
        <span className="workspace">
          <span className="dot" /> Workspace 01
        </span>
        <span className="char-count" style={{color:'var(--idea-card-count-color)'}}>{note.length}/500</span>
      </div>
    </div>
  );
};

export default IdeaCard;
